/**
 * @fileoverview Type definitions for analytics system
 * Defines interfaces for Google Analytics 4 event tracking
 */

/**
 * @typedef {Object} AnalyticsEvent
 * @property {string} eventName - Event name
 * @property {string} [eventCategory] - Event category
 * @property {string} [eventLabel] - Event label
 * @property {number} [eventValue] - Event value
 * @property {Record<string, any>} [parameters] - Additional event parameters
 * @property {number} timestamp - Event timestamp
 */

/**
 * @typedef {Object} PageViewEvent
 * @property {string} path - Page path
 * @property {string} title - Page title
 * @property {string} [referrer] - Referrer URL
 */

/**
 * @typedef {Object} ButtonClickEvent
 * @property {string} buttonName - Button name or label
 * @property {string} location - Location on page
 * @property {string} [destination] - Destination URL if applicable
 */

/**
 * @typedef {Object} ScrollDepthEvent
 * @property {number} percentage - Scroll depth percentage (0-100)
 * @property {string} page - Page path
 */

/**
 * @typedef {Object} OutboundLinkEvent
 * @property {string} url - Outbound link URL
 * @property {string} linkText - Link text
 */

/**
 * @typedef {Object} CalculatorUsageEvent
 * @property {string} calculatorType - Type of calculator used
 * @property {Record<string, any>} [inputs] - Calculator input values
 */

/**
 * @typedef {Object} StockSelectionEvent
 * @property {string} symbol - Stock symbol
 * @property {string} name - Stock name
 * @property {string} [sector] - Stock sector
 */

/**
 * Google Analytics 4 tracking ID
 */
export const GA4_TRACKING_ID = 'G-RBK22H8FL1';

/**
 * Scroll depth thresholds for tracking
 */
export const SCROLL_DEPTH_THRESHOLDS = [25, 50, 75, 90, 100];
